export default __webpack_public_path__ + "static/media/1_0020.79e3757e.webp";